module.exports = require('./helpers/bundle-url').getBundleURL('drLhz') + "../assets/images/de.49cb83e9.webp";